export const MODAL_OPEN = 'MODAL_OPEN'
export const MODAL_CLOSE = 'MODAL_CLOSE'



// WEBPACK FOOTER //
// ./src/constants/Modal.js